import { createSelector } from 'reselect';
import { getWidgetSlice } from './common-selectors';
export var getIsMobile = createSelector(getWidgetSlice, function (_a) {
    var isMobile = _a.isMobile;
    return isMobile;
});
export var getIsWidgetLoaded = createSelector(getWidgetSlice, function (_a) {
    var loaded = _a.loaded;
    return loaded;
});
export var getUniversity = createSelector(getWidgetSlice, function (_a) {
    var institution = _a.institution;
    return institution;
});
